import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const AssignedToSelect = ({
  value,
  onChange,
  workerOptions = [],
  teamOptions = [],
  partnerOptions = [],
  lockAssignmentFields = false
}) => {
  const { t } = useTranslation();

  const currentValue = value || '';
  const isWorker = currentValue.startsWith('worker:');
  const isTeam = currentValue.startsWith('team:');
  const isPartner = currentValue.startsWith('partner:');

  const workerValue = isWorker ? currentValue.replace('worker:', '') : null;
  const teamValue = isTeam ? currentValue.replace('team:', '') : null;
  const partnerValue = isPartner ? currentValue.replace('partner:', '') : null;

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '25px',
      height: '25px',
      backgroundColor: '#374151',
      borderColor: '#4B5563',
      '&:hover': { borderColor: '#6B7280' }
    }),
    menu: (base) => ({ ...base, backgroundColor: '#374151' }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isDisabled
        ? '#1f2937'
        : state.isFocused
          ? '#4B5563'
          : '#374151',
      color: state.isDisabled ? '#6b7280' : 'white',
      cursor: state.isDisabled ? 'not-allowed' : 'default',
      opacity: state.isDisabled ? 0.65 : 1,
      '&:hover': {
        backgroundColor: state.isDisabled ? '#1f2937' : '#4B5563'
      }
    }),
    singleValue: (base) => ({ ...base, color: 'white' }),
    input: (base) => ({ ...base, color: 'white' }),
    placeholder: (base) => ({ ...base, color: '#9CA3AF' })
  };

  return (
    <div className="space-y-1">
      <Select
        value={workerOptions?.find((opt) => opt.value === workerValue) || null}
        onChange={(selected) => onChange(selected ? `worker:${selected.value}` : null)}
        options={workerOptions || []}
        isOptionDisabled={(option) => option.isDisabled}
        isDisabled={lockAssignmentFields}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder={t('jobs.selectWorker')}
        isClearable={!lockAssignmentFields}
        styles={selectStyles}
      />
      <Select
        value={teamOptions?.find((opt) => opt.value === teamValue) || null}
        onChange={(selected) => onChange(selected ? `team:${selected.value}` : null)}
        options={teamOptions || []}
        isOptionDisabled={(option) => option.isDisabled}
        isDisabled={lockAssignmentFields}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder={t('jobs.selectTeam')}
        isClearable={!lockAssignmentFields}
        styles={selectStyles}
      />
      <Select
        value={partnerOptions?.find((opt) => opt.value === partnerValue) || null}
        onChange={(selected) => onChange(selected ? `partner:${selected.value}` : null)}
        options={partnerOptions || []}
        isDisabled={lockAssignmentFields}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder={t('jobs.selectPartner')}
        isClearable={!lockAssignmentFields}
        styles={selectStyles}
      />
    </div>
  );
};

export default AssignedToSelect;
